import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapLeafletComponent } from './components/map-leaflet/map-leaflet.component';

@NgModule({
  declarations: [MapLeafletComponent],
  imports: [CommonModule],
  exports: [MapLeafletComponent],
})
export class MapLeafletModule {}
